import {useQuoteField} from 'Quoting/components/hooks/useHandleQuoteFieldChange';
import {FormRowGrid, GridRowProps} from 'Quoting/components/shared/GridRow';
import {QuoteFormElement} from 'Quoting/components/shared/QuoteFormElement';
import {Map as ImmutableMap} from 'immutable';
import React from 'react';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {formatCurrencyValue} from './ACCBenefits';
import {accidentInjuriesPath} from './PropertyPaths/accidentInjuriesPath';

export const ParalysisDetails = () => {
  const {getQuoteFieldValue} = useQuoteField();
  const {selectedPlan} = useSelector((state: ReducerState) => state.quoteForm);

  const propertyPaths = accidentInjuriesPath(selectedPlan?.planIndex ?? 0, 0);
  const isGVA6Plan =
    getQuoteFieldValue<ImmutableMap<string, any>>(`benefitPackagingDetail.plans[${selectedPlan?.planIndex ?? 0}]`)?.get(
      'planCd'
    ) == 'GVA6';

  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'paralysis-details-row-1'},
      items: [
        {
          key: propertyPaths.paralysisDetails.incurralPeriod,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Incurral Period (Days)"
              value={getQuoteFieldValue<number>(propertyPaths.paralysisDetails.incurralPeriod)}
              disabled
              id={propertyPaths.paralysisDetails.incurralPeriod}
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.paralysisDetails.minimumDuration,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Minimum Duration (Days)"
              value={getQuoteFieldValue<number>(propertyPaths.paralysisDetails.minimumDuration)}
              disabled
              id={propertyPaths.paralysisDetails.minimumDuration}
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'paralysis-details-row-2'},
      items: [
        {
          key: propertyPaths.paralysisDetails.customizeBenefitAmount,
          hidden: true,
          element: (
            <QuoteFormElement
              elementType="FormControl"
              controlType="checkbox"
              label="Customize Benefit Amount"
              disabled
              checked={getQuoteFieldValue<boolean>(propertyPaths.paralysisDetails.customizeBenefitAmount)}
              id={propertyPaths.paralysisDetails.customizeBenefitAmount}
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.paralysisDetails.oneOrTwoLimbsAmount,
          element: (
            <QuoteFormElement
              elementType="Text"
              label={isGVA6Plan ? 'Paraplegia' : '1 or 2 Limbs'}
              adornment="money"
              value={formatCurrencyValue(
                getQuoteFieldValue<number>(propertyPaths.paralysisDetails.oneOrTwoLimbsAmount)
              )}
              id={propertyPaths.paralysisDetails.oneOrTwoLimbsAmount}
              disabled
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'paralysis-details-row-3'},
      items: [
        {
          key: propertyPaths.paralysisDetails.threeOrFourLimbsAmount,
          element: (
            <QuoteFormElement
              elementType="Text"
              label={isGVA6Plan ? 'Quadriplegia' : '3 or 4 Limbs'}
              adornment="money"
              value={formatCurrencyValue(
                getQuoteFieldValue<number>(propertyPaths.paralysisDetails.threeOrFourLimbsAmount)
              )}
              disabled
              id={propertyPaths.paralysisDetails.threeOrFourLimbsAmount}
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.paralysisDetails.maxBenefitNumber,
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              dropdownVariant="AttributeValue"
              label="Number of Times Benefit is Payable per Time Period"
              searchKey={`ACCParalysisBenefit.maxBenefitNumber`}
              value={getQuoteFieldValue<number>(propertyPaths.paralysisDetails.maxBenefitNumber)}
              disabled
              id={propertyPaths.paralysisDetails.maxBenefitNumber}
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'paralysis-details-row-4'},
      items: [
        {
          key: propertyPaths.paralysisDetails.timePeriodCd,
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              dropdownVariant="AttributeValue"
              label="Time Period"
              searchKey={`ACCParalysisBenefit.timePeriodCd`}
              value={getQuoteFieldValue<number>(propertyPaths.paralysisDetails.timePeriodCd)}
              disabled
              id={propertyPaths.paralysisDetails.timePeriodCd}
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
  ];
  return <FormRowGrid rows={rows} />;
};
